import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-probus.png'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "forgot-password" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"forgot-password--logo-wrap\"><img src=\"" + _imports_0 + "\"></div><div class=\"forgot-password--title\">Recover your account</div><p class=\"forgot-password--text\">Enter your email address to reset your password. You may need to check your spam folder or unblock <a href=\"mailto:info@probusandcar.com\">info@probusandcar.com</a></p>", 3)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = ["disabled"]

import { ref } from "vue"
import { useForgotPassword } from '@/store/user'
import { useRouter } from 'vue-router'
import { toastError } from '@/store/toasts'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const email = ref('')
const { forgotPassword, error, isPending } = useForgotPassword()
const router = useRouter()

toastError(error)

const onSubmit = async () => {
  await forgotPassword(email.value)
  router.push({ name: 'reset_password_code' })
}

return (_ctx: any,_cache: any) => {
  const _component_FormControl = _resolveComponent("FormControl")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSubmit, ["prevent"]),
        class: "forgot-password--form"
      }, [
        _createVNode(_component_FormControl, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          placeholder: "your email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-block forgot-password--form-continue-btn",
          disabled: _unref(isPending)
        }, "Continue", 8, _hoisted_7),
        _createVNode(_component_router_link, {
          to: { name: 'login' },
          class: "btn btn-block btn-secondary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("back to Login")
          ]),
          _: 1
        })
      ], 40, _hoisted_6)
    ])
  ]))
}
}

})